"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAdAccountRequestToJSON = exports.UpdateAdAccountRequestFromJSONTyped = exports.UpdateAdAccountRequestFromJSON = exports.instanceOfUpdateAdAccountRequest = void 0;
var runtime_1 = require("../runtime");
var AdAccountInternalRequestEntity_1 = require("./AdAccountInternalRequestEntity");
var AdAccountTaxObject_1 = require("./AdAccountTaxObject");
var BillingAddress_1 = require("./BillingAddress");
var Industry_1 = require("./Industry");
/**
 * Check if a given object implements the UpdateAdAccountRequest interface.
 */
function instanceOfUpdateAdAccountRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateAdAccountRequest = instanceOfUpdateAdAccountRequest;
function UpdateAdAccountRequestFromJSON(json) {
    return UpdateAdAccountRequestFromJSONTyped(json, false);
}
exports.UpdateAdAccountRequestFromJSON = UpdateAdAccountRequestFromJSON;
function UpdateAdAccountRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'industry': !(0, runtime_1.exists)(json, 'industry') ? undefined : (0, Industry_1.IndustryFromJSON)(json['industry']),
        'billingAddress': !(0, runtime_1.exists)(json, 'billing_address') ? undefined : (0, BillingAddress_1.BillingAddressFromJSON)(json['billing_address']),
        'taxId': !(0, runtime_1.exists)(json, 'tax_id') ? undefined : json['tax_id'],
        'taxIds': !(0, runtime_1.exists)(json, 'tax_ids') ? undefined : (json['tax_ids'].map(AdAccountTaxObject_1.AdAccountTaxObjectFromJSON)),
        'legalEntityName': !(0, runtime_1.exists)(json, 'legal_entity_name') ? undefined : json['legal_entity_name'],
        'internal': !(0, runtime_1.exists)(json, 'internal') ? undefined : (0, AdAccountInternalRequestEntity_1.AdAccountInternalRequestEntityFromJSON)(json['internal']),
    };
}
exports.UpdateAdAccountRequestFromJSONTyped = UpdateAdAccountRequestFromJSONTyped;
function UpdateAdAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'industry': (0, Industry_1.IndustryToJSON)(value.industry),
        'billing_address': (0, BillingAddress_1.BillingAddressToJSON)(value.billingAddress),
        'tax_id': value.taxId,
        'tax_ids': value.taxIds === undefined ? undefined : (value.taxIds.map(AdAccountTaxObject_1.AdAccountTaxObjectToJSON)),
        'legal_entity_name': value.legalEntityName,
        'internal': (0, AdAccountInternalRequestEntity_1.AdAccountInternalRequestEntityToJSON)(value.internal),
    };
}
exports.UpdateAdAccountRequestToJSON = UpdateAdAccountRequestToJSON;
